import { handleActions } from 'redux-actions';
import { GET_PLANS, GET_RECORDS } from '../actionTypes';
import { exerciseCheck } from '../initialState';

export default handleActions(
  {
    [GET_PLANS]: (state, action) => {
      return {
        ...state,
        plans: action.payload
      };
    },
    [GET_RECORDS]: (state, action) => {
      return {
        ...state,
        records: action.payload
      };
    }
  },
  exerciseCheck
);
